import { useEffect } from "react";
import { Link } from "react-router-dom";
import posts from "../data/posts";
import Seo from "./Seo";
import SiteNav from "./SiteNav";

const formatDate = (iso) =>
  new Date(`${iso}T00:00:00`).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

export default function BlogHome() {
  useEffect(() => {
    document.body.classList.add("blog-mode");
    return () => document.body.classList.remove("blog-mode");
  }, []);

  return (
    <div className="blog-shell">
      <Seo
        title="Blog"
        description="Field notes on DevOps, AI automation, and shipping production systems — from Jengo to the cluster they run on."
        path="/blog"
        image="/og/blog.png"
      />
      <SiteNav mode="blog" />
      <div className="blog-view">
        <div className="grain-overlay" />
        <aside className="blog-header-sticky">
          <span className="works-count mono uppercase">Writing</span>
          <h1 className="section-title grad-text">
            FIELD <span>NOTES</span>
          </h1>
          <p className="service-intro">
            Short notes on DevOps, AI automation, and shipping systems that hold up in production.
          </p>
        </aside>
        <main className="blog-main">
          <ol className="blog-index">
            {posts.map((post) => (
              <li key={post.slug}>
                <Link to={`/blog/${post.slug}`} className="blog-row">
                  <div className="blog-row-meta mono">
                    <time dateTime={post.date}>{formatDate(post.date)}</time>
                    <span className="blog-row-tag">{post.tags[0]}</span>
                  </div>
                  <div className="blog-row-body">
                    <h2>{post.title}</h2>
                    <p>{post.description}</p>
                  </div>
                  <span className="blog-row-more mono">Read →</span>
                </Link>
              </li>
            ))}
          </ol>
        </main>
      </div>
    </div>
  );
}
